<template>
  <div class="header navibar clearfix" id="navibar">
    <div class="navibar-wap clearfix">
      <div class="navibar-la">
        <ul class="fl">
          <li id="Jnb-tit-sites" class="nb-tit nb-menu nb-tit-sites" @mouseenter="selectIdx=0" @mouseleave="selectIdx=-1">
            太平洋网络
            <i class="nb-arrow"></i>
            <div class="nb-menulist" v-show="selectIdx==0">
                <div class="nb-menulist-inner nb-ml-bbs">
                <div class="nb-menuList-con">
                <a href="//www.pconline.com.cn/" target="_blank" class="nb-ml-item">电脑网</a>
                <a href="//www.pcauto.com.cn/" class="nb-ml-item">汽车网</a>
                <a href="//www.pclady.com.cn/" target="_blank" class="nb-ml-item">时尚网</a>
                <a href="//www.pcbaby.com.cn/"  target="_blank" class="nb-ml-item">亲子网</a>
                <a href="//www.pchouse.com.cn/" target="_blank" class="nb-ml-item">家居网</a>
                </div>
                <em class="nb-ml-arrow"></em>
                </div>
            </div>
          </li>
          <li class="nb-tit">
            <a href="//www.pcauto.com.cn/nation/" target="_blank">新车</a>
          </li>
          <li class="nb-tit">
            <a href="//price.pcauto.com.cn/" target="_blank">车型库</a>
          </li>
          <li class="nb-tit">
            <a href="//price.pcauto.com.cn/shangjia/" target="_blank">经销商</a>
          </li>
          <li class="nb-tit">
            <a href="//bbs.pcauto.com.cn/" target="_blank">论坛</a>
          </li>
          <li class="nb-tit">
            <a href="//wenda.pcauto.com.cn/" target="_blank">车问答</a>
          </li>
        </ul>
      </div>
      <div class="navibar-lc">
        <a href="//www.pcauto.com.cn/qcbj/" target="_blank">全国</a
        ><a href="//www.pcauto.com.cn/qcbj/bj/" target="_blank">北京</a
        ><a href="//www.pcauto.com.cn/qcbj/sh/" target="_blank">上海</a
        ><a href="//www.pcauto.com.cn/qcbj/gz/" target="_blank">广州</a
        ><a href="//www.pcauto.com.cn/qcbj/sz/" target="_blank">深圳</a
        ><a href="//www.pcauto.com.cn/qcbj/sc/" target="_blank">成都</a
        ><a href="//www.pcauto.com.cn/qcbj/wh/" target="_blank">武汉</a
        ><a href="//www.pcauto.com.cn/qcbj/jn/" target="_blank">济南</a
        ><a
          class="navibar-lc-more"
          href="//www.pcauto.com.cn/qcbj/citymap/"
          target="_blank"
          >>></a
        >
      </div>
      <div class="navibar-lb navL">
        <ul class="nb-info meg">
          <li class="nb-tit nb-tit-login" id="ajaxLogon" @mouseenter="selectIdx=1" @mouseleave="selectIdx=-1">
            <div id="Jlogin-tit" class="nb-tit nb-menu">
              <a target="_self" :href="loginUrl">登录</a>
              <i class="nb-arrow"></i>
              <div class="nb-menulist" v-show="selectIdx==1">
                  <div class="nb-menulist-inner">
                  <div class="nb-menuList-con nb-ml-loginway">
                  <a target="_self" href="//my.pcauto.com.cn/passport/login.jsp?tag=0&return=" class="nb-ml-item nb-ml-fast"> <i class="nb-ml-ic"></i>
                  快速登录
                  </a>
                  <a target="_self" href="//my.pcauto.com.cn/passport/login.jsp?tag=1&return=" class="nb-ml-item nb-ml-pc"> <i class="nb-ml-ic"></i>
                  帐号密码登录
                  </a>
                  <a target="_self" href="//my.pcauto.com.cn/passport/opens/authorize.jsp?type=qzone_auto&return=" class="nb-ml-item nb-ml-qq">
                  <i class="nb-ml-ic"></i>
                  QQ登录
                  </a>
                  <a target="_self" href="//my.pcauto.com.cn/passport/opens/authorize.jsp?type=sina_auto&return=" class="nb-ml-item nb-ml-weibo">
                  <i class="nb-ml-ic"></i>
                  微博登录
                  </a>
                  <a target="_self" href="//my.pcauto.com.cn/passport/opens/authorize.jsp?type=weixin_auto&return=" class="nb-ml-item nb-ml-weixin">
                  <i class="nb-ml-ic"></i>
                  微信登录
                  </a>
                  </div> <em class="nb-ml-arrow"></em>
                  </div>
              </div>
            </div>
            <div class="nb-tit">
              <a href="//my.pcauto.com.cn/passport/mobileRegister.jsp" target="_blank">注册</a>
            </div>
          </li>
          <li class="nb-tit nb-menu" id="Jnb-tit-bbs" @mouseenter="selectIdx=2" @mouseleave="selectIdx=-1">
            <a target="_blank" href="//bbs.pcauto.com.cn/">进入论坛</a>
            <i class="nb-arrow"></i>
            <div class="nb-menulist" v-show="selectIdx==2">
              <div class="nb-menulist-inner nb-ml-bbs">
                <div class="nb-menuList-con">
                  <dl>
                    <dt>最近访问</dt>
                    <dd id="Jnb-bbs-visit">
                      <span class="nb-ml-item">加载中</span>
                    </dd>
                    <dd id="Jnb-bbs-goindex">
                      <a
                        href="//bbs.pcauto.com.cn/"
                        target="_blank"
                        class="nb-ml-item nb-mlbs-sp"
                        >去论坛首页>></a
                      >
                    </dd>
                  </dl>
                  <dl id="Jnb-bbs-favb" class="nb-bbs-favb">
                    <dt class="nb-mlbs-sp">论坛收藏</dt>
                    <dd id="Jnb-bbs-favl">
                      <span class="nb-ml-item">加载中</span>
                    </dd>
                  </dl>
                </div>
                <em class="nb-ml-arrow"></em>
              </div>
            </div>
          </li>
          <li class="nb-tit nb-menu nb-tit-wap" @mouseenter="selectIdx=3" @mouseleave="selectIdx=-1">
            移动应用
            <i class="nb-arrow"></i>
            <div class="nb-menulist" v-show="selectIdx==3">
              <div type="text/template">
                <div class="nb-menulist-inner nb-ml-bbs">
                <div class="nb-menuList-con">
                <a href="//app.pcauto.com.cn/?ad=5328" target="_blank" class="nb-ml-item">手机客户端</a>
                <a href="//app.pcauto.com.cn/wap/?ad=5332" target="_blank" class="nb-ml-item">触屏版</a>
                <a href="//app.pcauto.com.cn/weixin/?ad=5334" target="_blank" class="nb-ml-item">微信平台</a>
                </div>
                <em class="nb-ml-arrow"></em>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: "vHeader",
  data() {
    return {
        selectIdx:-1,
        loginUrl: ''
    };
  },
  methods: {
      
  },
};
</script>

<style lang="scss">
.header {
  position: fixed;
  top: 0;
  left: 0;
  height: 32px;
  background-color: #fff;
  .nb-menulist .nb-ml-arrow{
   background: none !important;
  }
}
.nb-none{ display:none;}
.navibar .nb-arrow,
.nb-tit-user .nb-msgtip,
.nb-menulist .nb-ml-arrow,
.nb-menulist .nb-ml-ic,
.navibar .nb-tit-icon,
.nb-tit-message .msg-icon{background: url(//www1.pcauto.com.cn/header/images/nb-menuList-icon.png) no-repeat;}
.navibar{ min-width:1000px; text-align: left; position:relative; z-index:555; height: 32px; border-bottom:1px solid #ececec; background-color:#f8f8f8;color: #666; font:12px/28px "微软雅黑","宋体";}
.navibar-wap{ width:1200px; margin:0 auto;}
.navibar-la{ float:left; display: inline;margin-left: 80px;}
.navibar-lb{ float:right; display: inline;}
.navibar a{color: #666;}
.navibar a:hover{color: #f70;}
.navibar .nb-info,
.navibar .nb-tit{ display:inline; float:left;}
.navibar .nb-tit{ position: relative; line-height:28px; margin-right:13px;}
.navibar .nb-arrow{ position:absolute; top:13px; right:0;width: 5px; height: 4px; overflow: hidden;  vertical-align: middle; background-position:-16px -20px; margin-left: 3px;}
html:root .navibar .nb-arrow{ background-position:-16px -20px; 
transition:.25s;
-moz-transition:.25s; /* Firefox 4 */
-webkit-transition:.25s;  /* Safari 和 Chrome */
-o-transition:.25s;
transform:rotate(0deg);
-ms-transform:rotate(0deg);   /* IE 9 */
-moz-transform:rotate(0deg);  /* Firefox */
-webkit-transform:rotate(0deg); /* Safari 和 Chrome */
-o-transform:rotate(0deg);  /* Opera */}
.navibar .nb-tit-hover .nb-arrow{ background-position:-16px -8px;}
html:root .navibar .nb-tit-hover .nb-arrow{ background-position:-16px -20px; 
transition:.25s;
-moz-transition:.25s; /* Firefox 4 */
-webkit-transition:.25s;  /* Safari 和 Chrome */
-o-transition:.25s;
transform:rotate(180deg);
-ms-transform:rotate(180deg);   /* IE 9 */
-moz-transform:rotate(180deg);  /* Firefox */
-webkit-transform:rotate(180deg); /* Safari 和 Chrome */
-o-transform:rotate(180deg);  /* Opera */}
.navibar .nb-menu{ position: relative;  padding-right:8px;}
.navibar .nb-menulist{ position: absolute; width: 124px; padding-top:8px; top:27px; left:50%; margin-left:-63px;z-index:10; *background:url(about:blank); text-align:left;}
.navibar .nb-tit-hover .nb-menulist{ display: block;}
.navibar .nb-menulist-inner{ display:block; box-shadow: 0 0 5px rgba(0, 0, 0, 0.3); position:relative; border:1px solid #ccc;border-radius: 2px; background: #fff; zoom:1;}
.nb-menulist .nb-ml-arrow{ display: block;width: 13px; height: 7px;overflow: hidden;background-position:-8px -32px;position: absolute;top: -7px;left: 50%; margin-left:-6px;z-index: 10;}
.nb-menulist .nb-ml-item{display:block; position:relative; height: 30px;line-height: 30px; padding:0 10px; overflow:hidden; white-space:nowrap; text-overflow:ellipsis;text-overflow:clip;}
.nb-menulist .nb-ml-ic{display: inline; float: left; width:21px; margin-right:6px;_overflow: hidden;}
.nb-tit-sites .nb-menulist{width:70px; text-align:center; margin-left:-35px;}
/*论坛*/
.nb-ml-bbs{ color:#aaa;}
.nb-ml-bbs dt{font-weight:bold; height: 30px;line-height: 30px; margin-bottom:-5px; padding:0 15px;}
.nb-ml-bbs .nb-mlbs-sp{ border-top:1px dashed #ececec;}
.nb-ml-bbs .nb-bbs-favb{ display:none;}
/*登录*/
.navibar .nb-tit-login{ margin-right:0;}
.nb-ml-pc{ border-bottom: 1px dashed #ececec;}
.nb-ml-fast .nb-ml-ic{width:17px;height: 12px;background-position: 0px 0px;margin-top: 10px;}
.nb-ml-pc .nb-ml-ic{height: 15px;background-position: 0px -14px;margin-top: 8px;}
.nb-ml-qq .nb-ml-ic{height: 15px;background-position: 0px -31px;margin-top: 9px;}
.nb-ml-weibo .nb-ml-ic{height: 14px;background-position: 0 -48px;margin-top: 8px;}
.nb-ml-weixin .nb-ml-ic{width: 17px;height: 13px;background-position: 0 -64px;margin-top: 8px;}
/*个人中心*/
.navibar .nb-tit-user{ padding-left:25px;}
.navibar .user-link:hover{ text-decoration:none;}
.nb-tit-user .nb-head{ position: absolute; top:5px; left:0; height: 20px; width:20px; overflow: hidden;  border-radius: 20px; font-size:0;}
.nb-tit-user .nb-head img{ vertical-align: top;}
.navibar .nb-ml-user{ width:254px; left:0; margin-left:0;}
.nb-ml-user .nb-ml-arrow{  margin-left:-80px;}
.nb-ml-user .nb-menuList-con{ padding:12px 12px 0;}
.navibar .nb-pt-pic{ float:left; margin-right:10px;}
.navibar .nb-picTxt dt{ font-size:14px; line-height:1.3;}
.navibar .nb-picTxt dd{ line-height:2; color:#777;}
.navibar .nb-picTxt dd a{ color:#225599; }
.navibar .nb-picTxt dd a:hover{ color:#f70;}
.nb-user-info dt a{ color:#333;}
.nb-user-info dt a:hover{ color:#f70;}
.nb-user-info dd{ margin-top:3px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;}
.nb-user-info .apply-rz{ float:right;}
.navibar .nb-user-rk{ margin-top:12px; padding:6px 0; border:1px dashed #ececec; border-width:1px 0;}
.nb-user-rk .nb-ml-item{ padding:0 5px; float:left; width:104px;}
.navibar .nb-user-cyh { margin-top:12px;}
.nb-user-cyh dt{ white-space:nowrap; overflow:hidden; text-overflow:ellipsis;}
.nb-user-cyh dt a{ color:#777;}
.nb-user-cyh dt a:hover{ color:#f70;}
.nb-user-cyh dd{ margin-top:8px;}
.nb-user-cyh .nb-pt-pic img{border:1px solid #e5e5e5;}
.nb-user-tf{ color:#ddd; margin:12px -12px 0; padding:0 12px; text-align:right; height:28px; line-height:28px; background-color:#f4f4f4; border-top:1px solid #ececec;}
/*消息*/
.navibar .nb-tit-nomsg{ padding-right:0;}
.nb-tit-message{ width:16px; height:28px;}
.nb-tit-message .msg-icon{ position:absolute; top:8px; left:0; height: 13px; width:16px;overflow:hidden; line-height:999em; background-position: -5px -44px; padding:0; }
.navibar .nb-message-num{ position:absolute; top:2px; right:0; background: #f44; color: #fff;border-radius: 2px;padding: 0 2px;line-height: 14px;height: 14px;}
.nb-tit-message .nb-menulist{ width:132px;}
.navibar .nb-message-none{ display:none !important;}
.nb-menuList-con .nb-message-num{top:8px; right:15px;}
.nb-ml-mybbs .nb-ml-ic{ height:13px; background-position:0 -251px; margin-top:8px;}
.nb-ml-mycar .nb-ml-ic{ height:12px; background-position:0 -265px; margin-top:9px;}
.nb-ml-mycollect .nb-ml-ic{ height:14px; background-position:0 -280px; margin-top:8px;}
.nb-ml-mycmt .nb-ml-ic{ height:15px; background-position:0 -296px; margin-top:7px;}
.nb-ml-mycontribute .nb-ml-ic{ height:15px; background-position:0 -326px; margin-top:7px;}
.nb-ml-mycy .nb-ml-ic{ height:12px; background-position:0 -312px; margin-top:9px;}
.nb-ml-mymoney .nb-ml-ic{background-position:0 -350px;height:15px;margin-top:7px;}
.nb-tit-wap .nb-menulist{ width:96px; margin-left:-48px;}
.navibar-lc{float:left;padding-left:10px;}
.navibar-lc a{margin:0 6px;}
.navibar-lc em{color:#E9E9E9;}
.navibar-lc .navibar-lc-all{color:#B099B0;}
.navibar-lc .navibar-lc-all:hover{color:#f70;}
#JuserName{display: block;max-width: 160px;_width:100px;height: 28px;white-space: nowrap;overflow:hidden;text-overflow: ellipsis;}
/**宽屏ui**/
.b-webWideScreen .navibar{background:#f8f8f8;border-color:#ececec;}
.b-webWideScreen .navibar-wap{width:1200px;}
.b-webWideScreen .navibar .nb-tit-wap{ margin-right: 0;}
</style>
